import { ApiError } from '../../lib/api'
import { authClient } from '../../lib/auth-client'

export function sessionRetryDelay(value: string | null, now = Date.now()) {
  if (!value?.trim()) return 60
  const seconds = /^\d+$/.test(value.trim()) ? Number(value) : (Date.parse(value) - now) / 1000
  return Number.isFinite(seconds) && seconds >= 0 ? Math.max(1, Math.ceil(seconds)) : 60
}

export class BusinessSessionRateLimitError extends ApiError {
  constructor(public retryAfterSeconds: number) {
    super(429, 'rate_limit_exceeded', '')
  }
}

export async function readBusinessSession() {
  let retryAfter: string | null = null
  const result = await authClient.getSession({
    query: { disableCookieCache: true },
    fetchOptions: {
      onResponse: ({ response }) => {
        if (response.status === 429) retryAfter = response.headers.get('retry-after') ?? response.headers.get('x-retry-after')
      },
    },
  })
  if (result.error?.status === 429) throw new BusinessSessionRateLimitError(sessionRetryDelay(retryAfter))
  if (result.error) throw new Error('session_unavailable')
  return result.data?.user ?? null
}
